import React from "react";
import { useParams } from "react-router";
import { Col, Container, Row } from "reactstrap";
import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import CopyToClipboard from "src/components/CopyToClipboard/CopyToClipboard";
import { IconName } from "src/components/Icon/Icon";
import * as S from "../../../constants/StringConstants";
import "./BrokerQuotesWidget.scss";

interface RouteParams {
  id: string;
}

const BrokerQuotesWidget: React.FC = () => {
  const { id: brokerID } = useParams<RouteParams>();
  const brokerUrl = brokerID ? `${S.BQW_BROKER_URL}${brokerID}` : "";
  const clientUrl = brokerID ? `${S.BQW_CLIENT_URL}${brokerID}` : "";

  return (
    <CollapsibleCard title={S.PD_BROKER_QUOTES_LINKS_HEADER} iconName={IconName.BrokerBuilderQuotes} defaultOpen={true}>
      <Container>
        {brokerID && (
          <>
            <Row>
              <Col className="link-row">
                <a className="linkItem" href={brokerUrl} target="_blank">
                  {S.BQW_BROKER}
                </a>
                <CopyToClipboard textToCopy={brokerUrl} />
              </Col>
            </Row>

            <Row className="card-separator" />

            <Row>
              <Col className="link-row">
                <a className="linkItem" href={clientUrl} target="_blank">
                  {S.BQW_CLIENT}
                </a>
                <CopyToClipboard textToCopy={clientUrl} />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </CollapsibleCard>
  );
};

export default BrokerQuotesWidget;
